import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA : service worker avec mise à jour automatique après redéploiement
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // Vérifie une nouvelle version à chaque chargement
        registration.update();
        registration.addEventListener("updatefound", () => {
          const nw = registration.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              // Nouvelle version prête -> l'activer immédiatement
              nw.postMessage?.("SKIP_WAITING");
              registration.waiting?.postMessage?.("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {});
    // Recharge une seule fois quand le nouveau SW prend le contrôle
    let refreshed = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshed) return;
      refreshed = true;
      window.location.reload();
    });
  });
}
